const NAMESPACE = 'DUCKS/PARTNER_DATA';

export default NAMESPACE;
